<template>
  <div class="customer-editor">
    <header-tip>
      信息完整率： {{computeDataFullRate}}%
    </header-tip>
      <el-form :model="form" :rules="rules" ref="form" v-loading="loading">

        <el-row :gutter="0">
          <el-col :span="11">

            <el-form-item label="客户名称" :label-width="width" prop="name" :required="true" error="请输入客户名称">
              <el-input v-model="form.name" autocomplete="off" style="width: 300px;"></el-input>
              <el-button type="primary" @click="uploadIDCard">上传身份证</el-button>
            </el-form-item>
            <el-form-item label="客户分类" :label-width="width" prop="category" :required="true" error="请选择客户分类">
              <el-select v-model="form.category" placeholder="请选择">
                <el-option label="非常重要业主★★★★★" value="1"></el-option>
                <el-option label="重要客户★★★★" value="2"></el-option>
                <el-option label="一般业主★★★" value="3"></el-option>
                <el-option label="问题客户★★" value="4"></el-option>
                <el-option label="反对客户★" value="5"></el-option>
                <el-option label="其他" value="6"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="所属组织" :label-width="width" prop="organization_project_id" :required="true" error="请选择所属组织">
<!--              <el-input v-model="form.organization" autocomplete="off"></el-input>-->
              <el-select v-model="form.organization_project_id" clearable filterable placeholder="所属组织">
                <el-option
                  v-for="item in project_list"
                  :key="item.id"
                  :label="item.name"
                  :value="item.id">
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="性别" :label-width="width" prop="sex" :required="true" error="选择性别">
              <el-radio v-model="form.sex" label="1">男</el-radio>
              <el-radio v-model="form.sex" label="2">女</el-radio>
            </el-form-item>
            <el-form-item label="民族" :label-width="width" prop="nation" :required="true" error="请选择民族">
              <el-select v-model="form.nation" filterable placeholder="请选择">
                <el-option v-for="item in nativeList" :key="item.value" :label="item.label" :value="item.value"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="国籍" :label-width="width" prop="country" :required="true" error="选择国籍">
              <el-select v-model="form.country" filterable placeholder="请选择">
                <el-option v-for="item in countryList" :key="item.value" :label="item.label" :value="item.value"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="证件类型" :label-width="width" prop="credentials_type" :required="true" error="请选择证件类型">
              <el-select v-model="form.credentials_type" filterable placeholder="请选择">
                <el-option v-for="item in credentialsList" :key="item.value" :label="item.label" :value="item.value"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="证件号码" :label-width="width" prop="credentials_code" :required="true" error="请输入证件号码">
              <div style="display: flex;">
                <el-input v-model="form.credentials_code" autocomplete="off"></el-input>
                <el-button type="primary" @click="createCode">随机</el-button>
              </div>
              <span style="color: red;">证件必填，没有的可用手机号，不要填写“无”或“0000000……”之类的，没有的点击【随机】</span>
            </el-form-item>
            <el-form-item label="联系电话" :label-width="width" prop="contact_number" :required="true" error="请输入联系电话">
              <el-input v-model="form.contact_number" autocomplete="off"></el-input>
            </el-form-item>
            <el-form-item label="出生日期" :label-width="width" prop="birthday" :required="true" error="请选择出生日期">
              <el-date-picker v-model="form.birthday" value-format="yyyy-MM-dd" type="date" placeholder="选择日期"></el-date-picker>
            </el-form-item>
            <el-form-item label="籍贯" :label-width="width" prop="native_place" :required="true" error="请填写籍贯">
              <el-input v-model="form.native_place" autocomplete="off"></el-input>
            </el-form-item>
            <el-form-item label="户口所在地" :label-width="width" prop="registered_residence" :required="true" error="请填写户口所在地">
              <el-input type="textarea" v-model="form.registered_residence"></el-input>
            </el-form-item>


          </el-col>
          <el-col :span="1">&nbsp;</el-col>
          <el-col :span="11">

            <el-form-item label="省/市" prop="province_city" :label-width="width">

              <el-col :span="12">
                <el-select v-model="form.province" @change="changeProvince" filterable placeholder="请选择">
                  <el-option v-for="item in provinceList" :key="item.id" :label="item.name" :value="item.id"></el-option>
                </el-select>
              </el-col>
              <el-col class="line" :span="1">&nbsp;</el-col>
              <el-col :span="11">
                <el-select v-model="form.city" filterable placeholder="请选择">
                  <el-option v-for="item in cityList" :key="item.id" :label="item.name" :value="item.id"></el-option>
                </el-select>
              </el-col>

            </el-form-item>

            <el-form-item label="家庭地址" :label-width="width" prop="home_address" :required="true" error="请填写家庭地址">
              <el-input v-model="form.home_address" autocomplete="off"></el-input>
            </el-form-item>
            <el-form-item label="邮寄地址" :label-width="width" prop="post_address" :required="true" error="请填写邮寄地址">
              <el-input v-model="form.post_address" autocomplete="off"></el-input>
            </el-form-item>

            <el-form-item label="文化程序" :label-width="width" prop="cultural_procedures">
              <el-select v-model="form.cultural_procedures" filterable placeholder="请选择">
                <el-option v-for="item in culturalList" :key="item.value" :label="item.label" :value="item.value"></el-option>
              </el-select>
            </el-form-item>

            <el-form-item label="婚姻状况" :label-width="width" prop="marital_status">
              <el-radio v-model="form.marital_status" label="1">未婚</el-radio>
              <el-radio v-model="form.marital_status" label="2">已婚</el-radio>
              <el-radio v-model="form.marital_status" label="0">其它</el-radio>
            </el-form-item>

            <el-form-item label="常住类型" :label-width="width" prop="live_type">
              <el-radio v-model="form.live_type" label="1">户籍</el-radio>
              <el-radio v-model="form.live_type" label="2">非户籍</el-radio>
            </el-form-item>

            <el-form-item label="客户类型" :label-width="width" prop="type" :required="true" error="请选择客户类型">
              <el-checkbox-group v-model="form.type">
                  <el-checkbox label="1">业主</el-checkbox>
                  <el-checkbox label="2">租户</el-checkbox>
                  <el-checkbox label="3">住户</el-checkbox>
                  <el-checkbox label="4">共有人</el-checkbox>
                  <el-checkbox label="5">开发商</el-checkbox>
                  <el-checkbox label="9">其它</el-checkbox>
                </el-checkbox-group>
            </el-form-item>

            <el-form-item label="紧急联系人" :label-width="width" prop="emergency_contact" :required="true" error="请输入紧急联系人">
              <el-input v-model="form.emergency_contact" autocomplete="off"></el-input>
            </el-form-item>

            <el-form-item label="紧急联系人电话" :label-width="width" prop="emergency_number" :required="true" error="请输入紧急联系人电话">
              <el-input v-model="form.emergency_number" autocomplete="off"></el-input>
            </el-form-item>

            <el-form-item label="物业费日期" :label-width="width">
<!--               <el-date-picker v-model="form.fee_date" value-format="yyyy-MM-dd" type="daterange" range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期"></el-date-picker>-->

              <el-row>
                <el-col :span="10">
                  <el-date-picker
                    v-model="form.fee_start_date"
                    type="date"
                    format="yyyy-MM-dd"
                    value-format="yyyy-MM-dd"
                    clearable
                    placeholder="选择开始时间">
                  </el-date-picker>
                </el-col>
                <el-col :span="4">至</el-col>
                <el-col :span="10">
                  <el-date-picker
                    v-model="form.fee_end_date"
                    type="date"
                    format="yyyy-MM-dd"
                    value-format="yyyy-MM-dd"
                    clearable
                    placeholder="选择结束时间">
                  </el-date-picker>
                </el-col>
              </el-row>
            </el-form-item>

          </el-col>
        </el-row>


      </el-form>

      <div class="editor-footer">
        <div>
          <el-button type="danger"  @click="transferCustomer"  v-if="!!id">转企业</el-button>
        </div>
        <div style="display: flex;flex-direction: row;">
          <el-button @click="visable = false">取 消</el-button>
          <el-button type="primary" v-if="is_edit&&ERP.isPermission(3004001006)" @click="submitForm('form')">{{confirmText}}</el-button>
        </div>
      </div>

  </div>
</template>

<script>

  import Common from './common.js'
  import Http from "./common/Http";
  import moment from "moment";
  import HeaderTip from "../Common/header-tip";

  export default {
    name: "personal-basic-editor",
    components: {HeaderTip},
    emits: ['input'],
    props: {
      value: {
        type: Boolean,
        default() {
          return false
        }
      },
      id: {
        type: [Number, String],
        default() {
          return 0
        }
      },
      width: {
        type: String,
        default() {
          return '110px'
        }
      },
      is_edit:{
        type: Boolean,
        default() {
          return true
        }
      }
    },
    data(){
      return{
        visable: this.value,
        loading: false,
        form: this.getFormData({}),
        old_form: this.getFormData({}),
        rules: {
          name: [
            { required: true, message: '请输入名称', trigger: 'blur' },
            { min: 1, max: 50, message: '长度在 1 到 50 个字符', trigger: 'blur' }
          ],
          category: [
            {required: true, message: '请选择客户分类', trigger: 'change'}
          ],
          organization_project_id: [
            { required: true, message: '请选择所属组织', trigger: 'change' },
          ],
          sex: [
            {required: true, message: '请选择性别', trigger: 'change'}
          ],
          nation: [
            {required: true, message: '请选择民族', trigger: 'change'}
          ],
          country:[
            {required: true, message: '请选择国籍', trigger: 'change'}
          ],
          credentials_type: [
            {required: true, message: '请选择证件类型', trigger: 'change'}
          ],
          credentials_code: [
            {required: true, message: '请输入证件号码', trigger: 'blur'}
          ],
          contact_number: [
            {required: true, message: '请输入联系电话', trigger: 'blur'}
          ],
          birthday: [
            {required: true, message: '请选择出生日期', trigger: 'change'}
          ],
          native_place: [
            {required: true, message: '请输入籍贯', trigger: 'blur'}
          ],
          registered_residence: [
            {required: true, message: '请输入户口所在地', trigger: 'blur'}
          ],
          home_address: [
            {required: true, message: '请输入家庭地址', trigger: 'blur'}
          ],
          post_address:[
            {required: true, message: '请输入邮寄地址', trigger: 'blur'}
          ],
          type: [
            { type: 'array', required: true, message: '请至少选择一个客户类型', trigger: 'change' }
          ],
          emergency_contact: [
            {required: true, message: '请输入紧急联系人', trigger: 'blur'}
          ],
          emergency_number: [
            {required: true, message: '请输入紧急联系人电话', trigger: 'blur'}
          ],

        },
        nativeList: ["汉","朝鲜","满","侗","瑶","白","土家","哈尼","哈萨克","傣","黎","蒙古","僳僳","佤","畲","高山","拉祜","水","东乡","纳西","景颇","柯尔克孜","回","土","达斡尔","仫佬","羌","布朗","撒拉","毛南","仡佬","锡伯","阿昌","藏","普米","塔吉克","怒","乌孜别克","俄罗斯","鄂温克","德昂","保安","裕固","京","维吾尔","塔塔尔","独龙","鄂伦春","赫哲","门巴","珞巴","基诺","苗","彝","壮","布依"].map(item => {
          return {value: item, label: item}
        }),
        countryList: [{value: '中华人民共和国', label: '中华人民共和国'}],
        credentialsList: [{"value":"1","label":"居民身份证"},{"value":"11","label":"离休干部荣誉证"},{"value":"12","label":"护照"},{"value":"9","label":"文职干部证"},{"value":"6","label":"士兵证"},{"value":"8","label":"军官退休证"},{"value":"2","label":"临时身份证"},{"value":"15","label":"外国人永久居留证"},{"value":"16","label":"其他"},{"value":"13","label":"港澳台同胞来往通行证"},{"value":"10","label":"文职干部退休证"},{"value":"3","label":"户口簿"},{"value":"4","label":"军官证"},{"value":"5","label":"警官证"},{"value":"7","label":"军事学院证"},{"value":"14","label":"边民出入境通行证"},{"value":"17","label":"居民身份证（台）"}],
        provinceList: [],
        cityList: [],
        culturalList: [{"value":"1","label":"文盲"},{"value":"2","label":"初中及以下"},{"value":"3","label":"高中或中专"},{"value":"4","label":"大专"},{"value":"5","label":"本科"},{"value":"6","label":"硕士"},{"value":"7","label":"博士"},{"value":"8","label":"其他"}],
        confirmText: '保 存',
        project_list:[],
        id_card_number_obj:{
          status:0,
          message:'',
          is_save:false
        },

      }
    },
    mounted() {
      this.getProjectList();
      this.getData()
      this.showConfirmText()
    },
    watch: {
      value(val) {
      	this.visable = val
      },
      visable(val) {
        this.$emit('input', val)
      },
      id(val) {
        if(this.visable) {
          this.getData()
          this.showConfirmText()
        }
      }
    },
    methods: {
      createCode(){
        this.form.credentials_code="无证件_"+(new Date()).getTime().toString()
      },
      getFormData(data) {
        let object = {
          id: 0,
          name: '',
          category: '',
          organization: '',
          organization_project_id:"",
          nation: '',
          country: '',
          credentials_type: '',
          credentials_code: '',
          contact_number: '',
          birthday: '',
          native_place: '',
          registered_residence: '',
          province: '',
          city: '',
          home_address: '',
          post_address: '',
          cultural_procedures: '',
          marital_status: '',
          live_type: '',
          type: [],
          emergency_contact: '',
          emergency_number: '',
          fee_date: '',
          fee_start_date:'',
          fee_end_date:'',
          sex: '',
        }

        if(data.id) {

          data.sex += ''
          data.category = data.category === 0 ? '' : data.category += ''
          data.marital_status += ''
          data.credentials_type = data.credentials_type === 0 ? '' : data.credentials_type += ''
          data.live_type = data.live_type === 0 ? '' : data.live_type += ''
          data.cultural_procedures = data.cultural_procedures == 0 ? '' : data.cultural_procedures += ''
          data.province = data.province === 0 ? '' : data.province
          data.city = data.city === 0 ? '' : data.city
          if(typeof data.type == 'string') data.type = data.type.split(',')
          if(!data.fee_date && data.fee_start_date) data.fee_date = [Common.timeFormat(data.fee_start_date, false), Common.timeFormat(data.fee_end_date, false)]
          if(data.fee_start_date) {
            data.fee_start_date=Common.timeFormat(data.fee_start_date, false)
          }else {
            data.fee_start_date=""
          }
          if(data.fee_end_date) {
            data.fee_end_date=Common.timeFormat(data.fee_end_date, false)
          }else {
            data.fee_end_date=""
          }
          if(data.birthday){
            if(data.birthday.indexOf('-')<1){
              data.birthday = data.birthday > 0 ? Common.timeFormat(data.birthday, false) : ''
            }
          }


          return Object.assign(object, data)
        } else {
          return object
        }
      },

      getData() {

        let callback = res => {

          this.getRegion(0, res => {
            this.provinceList = res
            if(this.form.province) {
              this.getRegion(this.form.province, res => {
                this.cityList = res
              })
            }
          })

        }

        if(this.id > 0) {
          this.loading = true
          this.$myhttp.get('admin/Customer/getPersonalBasicInfo?customer_id='+this.id).then(backdata => {
            let res = backdata.data
            if(res.code == 200) {
              this.form = this.getFormData(res.data)
              this.old_form = this.getFormData(res.data)
              callback()
            } else {
              this.$message.error('获取客户信息出错！');
            }
            this.loading = false
          })
        } else {
          this.form = this.getFormData({})
          this.old_form=this.getFormData({})
          callback()
        }

      },

      getRegion(parentId = 0, callback) {
        this.$myhttp.get('admin/Customer/getRegion?parent_id=' + parentId).then(backdata => {
          if(backdata.status == 200) {
            callback(backdata.data)
          } else {
            this.$message.error('获取省市信息出错！');
          }
          this.$Loading.finish();
        });
      },
      changeProvince(proviceId) {
        this.form.city = ''
        this.getRegion(proviceId, res => {
          this.cityList = res
        })
      },
      submitForm(formName) {
        let that = this
        this.$refs[formName].validate((valid) => {
          if (valid) {

            let data = Object.assign({}, this.form)

            if(!data.organization_project_id){
              window.alert("请选择归属组织（项目）");
              return false;
            }
            data.type = data.type.join(',')

            let old_data = Object.assign({}, this.old_form)
            old_data.type = old_data.type.join(',')

            if(JSON.stringify(data) === JSON.stringify(old_data)) {
              this.$message.warning('数据未修改，请修改后再提交！')
              return false
            }
            data.old_form = JSON.stringify(old_data);

            this.$myhttp.post('admin/Customer/savePersonalBasic', data).then(backdata => {
              let res = backdata.data
              this.$message({
                message: res.msg,
                type: res.code == 200 ? 'success' : 'error'
              })
              if(res.code == 200) {
                this.$emit('callback', res.customer_id)
              }

              this.$Loading.finish();
            });

          } else {
            that.$message.error('请检查输入项！');
            return false;
          }
        });
      },
      showConfirmText() {
        this.confirmText = this.id > 0 ? '保 存' : '下一步'
      },
      getProjectList(){
        const that=this;
        ERP.getRequest({
          url:"admin/Project/getProjectList",
          data:{}
        },ret=>{
          if(ret.code){
            that.project_list=ret.data;
          }
        })
      },
      reIDCardNumber(){
        const that=this;
        ERP.getRequest({
          url:"admin/Customer/reIDCardNumber",
          data:{
            id:that.form.id,
            IDCardNumber:that.form.credentials_code
          }
        },ret=>{
          if(ret.code){
            that.id_card_number_obj=ret.data;
          }
        })
      },
      uploadIDCard(){
        const that=this;
        Http.uploadFile2(data=>{
          that.$message.success("上传成功");

          let birthday=formatDateString(data['出生'].words)

          that.form.name=data['姓名'].words;
          that.form.nation=data['民族'].words;
          that.form.sex=data['性别'].words==='女'?'2':'1';
          that.form.registered_residence=data['住址'].words;
          that.form.birthday=birthday;
          that.form.credentials_code=data['公民身份号码'].words;
        },"/admin/Customer/idCardImage",{idCardSide:"front"})
      },
      transferCustomer(){
        const that=this;
        that.$confirm('当前操作为转换客户性质，转换类型后，请重新填写客户信息。是否继续？', '提示', ).then(()=>{
          ERP.postRequest({
            url:"admin/Customer/transferCustomer",
            data:{
              customer_id:that.form.customer_id,
            }
          },ret=>{
            if(ret.code===1){
              that.$message.success("转换成功");
              that.$emit('callback', that.form.customer_id)
              that.visable=false;
            }else {
              that.$message.error(ret.msg||"转换失败");
            }
          })
        }).catch(()=>{
          that.$message.error("放弃转换");
        })
      }
    },
    computed:{
      computeDataFullRate(){
        return computeDataFull(this.form)
      }
    }
  }

  const formatDateString=(dateString)=> {
    // 确保输入是字符串
    dateString = dateString.toString();

    // 提取年、月、日
    const year = dateString.substring(0, 4);
    const month = dateString.substring(4, 6);
    const day = dateString.substring(6, 8);

    // 拼接成目标格式
    return `${year}-${month.padStart(2, '0')}-${day.padStart(2, '0')}`;
  }
  //计算信息完整率
  const computeDataFull=(obj)=>{
    const required_array =['name','category','organization_project_id','sex','nation','country','credentials_type','credentials_code','contact_number','birthday','native_place','registered_residence','home_address','post_address','type','emergency_contact','emergency_number'];
    let complete_num=0;
    let all_num=required_array.length;
    required_array.forEach(item => {
      if (typeof obj[item]==="undefined") {
        return false;
      }
      if(typeof obj[item]==='string'&&obj[item]!==''){
        complete_num++;
      }else if(typeof obj[item]==='number'&&obj[item]!==0){
        complete_num++;
      }else if(typeof obj[item]==='object'&&obj[item]!==null&&Object.keys(obj[item]).length>0){
        complete_num++;
      }
    })
    return (complete_num/all_num*100).toFixed(2)
  }
</script>

<style lang="scss" scoped="scoped">

  @import "./common.scss";

  .line {
    text-align: center;
  }
  .editor-footer{
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    border-top: 1px solid #e4e4e4;
    padding-top: 5px;
  }



</style>



// WEBPACK FOOTER //
// src/components/Admin/Customer/personal-basic-editor.vue